import React, {Component} from "react";
import ReactDom,{ render } from 'react-dom';
import axios from 'axios';
import { Redirect } from 'react-router';
import TMenus from './topmenus';

//import { Button, Form, FormGroup, Label, Input, FormText } from 'reactstrap';

var images = require.context('../../assets/images/', true);

export default class Messages extends Component {

    constructor(props) {
        super(props);
        var refur='';
        
        this.state = {
            style: {},
            email:'',
            password:'',
             loginMessage:'',
             scope:'',
             client_id:'',
             grant_type:'',
             client_secret:'',
             redirect_uri:'',
             code:'',
             myAttachInfo:[]
        };
    }

    componentDidMount() {
        setTimeout(function () {
            this.setState({style: {display:'none'}});
        }.bind(this),1000)
       // console.log("Access",localStorage.getItem('zohoToken'));
       // console.log("Refresh Access",localStorage.getItem('zohoRefreshtoken'));
        //console.log("qury",this.props.match.params.accountId);
        var params = {
        		token:localStorage.getItem('zohoToken'),
        		accountId:this.props.match.params.accountId,
        		folderId:this.props.match.params.folderId,
        		messageId:this.props.match.params.messageId,
        		attachmentId:this.props.match.params.attachmentId,
        		attachmentName:this.props.match.params.attachmentName,
        		subject:this.props.match.params.subject
        }
        axios.post('http://autometrics.in/oauth2/myAttachment',params,{
            headers:{
                'authorization': 'multipart/form-data',
                'Access-Control-Allow-Origin':"*",
                'Access-Control-Allow-Methods':'GET, POST, OPTIONS, PUT, DELETE, TOKEN',
                'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token'
               // 'authorization': 'Zoho-oauthtoken 1000.ecb6dbd17a44125ce5434f5f45148278.a54f59a27d9e9db5383f85ba3002ccf2' 
            }
        })
          .then( response => {
             // console.log(response);
        	  if(response == 'INVALID_OAUTHTOKEN')
    		  {
        		  this.setState({
                	  myAttachInfo:"Token has expired, Please use Refresh Token option"
                  });
    		  }
             
            //console.log(response);
          })
          .catch(function (error) {
            console.log(error);
          });
    }
    
    changeHandler = (event) => {

        let name = event.target.name;
        let value = event.target.value;
        this.setState({[name]:value});
    }
    
 
    render() {
        let style = this.state.style;
        const background = require('../../assets/images/auth-layer.png');
       console.log("Attachment Content ",this.state.myAttachInfo)
       
       
        return (
            <div>
                {/* Loader starts */}
                <div className="loader-wrapper" style={style}>
                    <div className="loader bg-white">
                        <div className="line"></div>
                        <div className="line"></div>
                        <div className="line"></div>
                        <div className="line"></div>
                        <h4>Have a great day at work today <span>&#x263A;</span></h4>
                    </div>
                </div>
                {/* Loader ends */}

                {/*page-wrapper Start*/}
                <div className="page-wrapper">
                    <div className="container-fluid">
                        {/*login page start*/}
                        <div className="authentication-main" >
                            <div className="row">
                                <div className="col-md-4 p-0">
                                    <div className="auth-innerleft" style ={ { backgroundImage: "url("+background+")" } }>
                                        <div className="text-center">
                                            <img src={require('../../assets/icons/logo.png')}
                                                    className="logo-login" style={{width:'75%'}} alt=""/>
                                               <hr/>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-8 p-0">
                                    <div className="auth-innerright">
                                        <div className="authentication-box">
                                        	<TMenus />
                                            <h4>My Attachments</h4>
                                            
                                            <div className="card mt-4 p-4 mb-0" style={{overflowX:'auto'}}>
                                            	<table className="table table-bordered">
                                            		<tr>
                                            			<th>{this.state.myAttachInfo}</th>
                                            		</tr>
                                            		
                                            	</table>
                                            	
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*login page end*/}
                    </div>
                </div>
                {/*page-wrapper Ends*/}

            </div>

        )
    }
}



